module.exports = "/assets/data/381002b927ecc2b3aeb86b6fe4ff302d-HU5.data.json";